export type CanonicalSystemStatus = "healthy" | "degraded";
export type SystemStatusValue = CanonicalSystemStatus | "ok" | (string & {});

export function normalizeSystemStatus(status?: string | null): string | null {
  if (!status) return status ?? null;
  if (status === "ok") return "healthy";
  return status;
}
